import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Cada vez que se navega a una página se hace un scrollTop para situar la página en ese elemento.
 */
const useScrollToTop = (selectorNode?: string) => {
	const location = useLocation();

	const scrollToTop = () => {
		const element = selectorNode ? document.querySelector(selectorNode) : window;
		if (element) {
			element.scroll(0, 0);
		}
	};

	useLayoutEffect(() => {
		scrollToTop();
	}, [location.pathname]);
};
export default useScrollToTop;
